import { useEffect, useState } from 'react'
import { GetBankTransferData } from '../../../Services/OrderService'
import { useConfig } from '../../../Providers/ConfigProvider'

const useGetBankTransferData = (siteId) => {
    const { api } = useConfig()
    const [bankTransferData, setBankTransferData] = useState(null)

    useEffect(() => {
        handleGetBankTransferData()
    }, [api])

    const handleGetBankTransferData = () => {
        GetBankTransferData(api, siteId).then(res => {
            setBankTransferData(res.data)
        }).catch(e => {
            console.log(e)
            setBankTransferData(null)
        })
    }

    return { bankTransferData }
}

export default useGetBankTransferData